import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class JsonDateInterceptor implements HttpInterceptor {
  private _isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((val: HttpEvent<any>) => {
        if (val instanceof HttpResponse) {
          const body = val.body;
          this.transformResponseBody(body);
        }
        return val;
      })
    );
  }
  private isIsoDateString(value: any): boolean {
    if (typeof value === 'string') {
      return this._isoDateFormat.test(value);
    }
    return false;
  }

  private transformResponseBody(body: any) {
    if (body === null || body === undefined || typeof body !== 'object') {
      return body;
    }
    if (body instanceof Array) {
      body = [...body];
    }
    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isIsoDateString(value)) {
        body[key] = new Date(value);
      } else if (typeof value === 'object') {
        body[key] = this.transformResponseBody(value);
      }
    }
    return body;
  }
}
